
import { Component, Ref, Vue } from 'vue-property-decorator'
import AdminAcademyList from '@/components/templates/manage/AdminAcademyList.vue'
import ModalRegistAcademy from '@/views/modal/manage/ModalRegistAcademy.vue'
import ModalEditAcademy from '@/views/modal/manage/ModalEditAcademy.vue'
import { AcademyList } from '@/models/manage/AcademyList'
import { AcademiesApi } from '@/api/methods/manage/AcademiesApi'

/**
 * 塾一覧
 */
@Component({
  components: {
    AdminAcademyList,
    ModalRegistAcademy,
    ModalEditAcademy,
  },
})
export default class AdminAcademies extends Vue {
  /** 塾一覧レイアウト */
  @Ref()
  adminAcademyList!: AdminAcademyList

  /** 塾登録モーダル */
  @Ref()
  modalRegistAcademy!: ModalRegistAcademy

  /** 塾編集モーダル */
  @Ref()
  modalEditAcademy!: ModalEditAcademy

  /** 1ページの最大件数 */
  private readonly MAX_PER_PAGE = 7

  /** 塾一覧 */
  private academyList: AcademyList[] = []

  /** 塾数 */
  private academyNumber = 0

  /** ページ数 */
  private pageLength = 0

  /** 現在のページ */
  private currentPage = 1

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()

    // 塾一覧取得
    await this.getAcademyList()

    this.$loading.complete()
  }

  /**
   * 塾更新後の処理(登録・編集モーダル内で呼び出し)
   */
  private async afterUpdateAcademy(): Promise<void> {
    this.$loading.start()

    // 塾一覧取得
    await this.getAcademyList()

    this.$loading.complete()
  }

  /**
   * 塾一覧取得
   */
  private async getAcademyList(): Promise<void> {
    // 教室一覧取得
    const academyList = await AcademiesApi.searchAcademies(
      this.currentPage,
      this.MAX_PER_PAGE,
      this.adminAcademyList.textInputedSearch()
    )

    // 塾数を設定
    this.academyNumber = academyList.totalCount

    // 取得対象の合計数から、全体のページ数を算出
    const length = academyList.totalCount
    const divideNumber = Math.floor(length / this.MAX_PER_PAGE)
    this.pageLength = length % this.MAX_PER_PAGE ? divideNumber + 1 : divideNumber

    // 教室一覧を設定
    this.academyList = academyList.academies.map((academy) => {
      return {
        academyId: academy.id,
        academyCode: academy.code,
        academyName: academy.name,
      }
    })
  }

  /**
   * 塾登録ボタン押下時のイベント
   */
  private clickCreateAcademyButton(): void {
    // モーダルを開く
    this.modalRegistAcademy.show()
  }

  /**
   * 塾名検索
   */
  private async searchAcademy(): Promise<void> {
    this.$loading.start()

    // 現在のページ数を初期値に戻す
    this.currentPage = 1

    // 塾一覧再取得
    await this.getAcademyList()

    this.$loading.complete()
  }

  /**
   * 削除ボタン押下時のイベント
   *
   * @param academyId 塾ID
   */
  private async clickDeleteButton(academyId: number): Promise<void> {
    if (!confirm('塾を削除しますか？')) {
      return
    }

    this.$loading.start()

    // 削除
    await AcademiesApi.deleteAcademy(academyId)

    // 塾一覧再取得
    await this.getAcademyList()

    this.$loading.complete()
  }

  /**
   * 塾情報編集ボタン押下時のイベント
   *
   * @param academyId 塾ID
   */
  private async clickEditAcademyButton(academyId: number): Promise<void> {
    // モーダルを開く
    await this.modalEditAcademy.show(academyId)
  }

  /**
   * ページリンク押下時の処理
   *
   * @param value ページ番号/戻る/進む
   */
  private async changePage(value: number): Promise<void> {
    this.$loading.start()

    this.currentPage = value

    // 塾情報再取得
    await this.getAcademyList()

    this.$loading.complete()
  }
}
